import React from "react";

export default function getFiltersString(FiltersParams) {
  const {
    PriceRange,
    PropertySize,
    PropertyType,
    PropertySubType,
    Purpose,
    City,
    Confirmation,
    LandUnit,
    Bedrooms,
    Bathrooms,
  } = FiltersParams;


  let FinalString = "";
  /* Property Type */
  if (PropertyType !== "*") FinalString += `propertyType:=${PropertyType} && `;
  /* Property Sub Type */
  if (PropertySubType !== "*")
    FinalString += `propertySubType:=${PropertySubType} && `;
  /* Purpose */
  if (Purpose !== "*")
    FinalString +=
      Purpose === "rent"
        ? `availableForRent:=true && `
        : `availableForSale:=true && `;
  /* City */
  if (City !== "*") FinalString += `city:=${City} && `;
  /* Land Unit */
  if (LandUnit !== "*")
    FinalString += `landAreaUnit:=${LandUnit} && landArea:[${PropertySize.join(
      ".."
    )}] && `;
  /* Confirmation */
  if (Confirmation !== "*")
    FinalString += `confirm-property:=${Confirmation === "confirmed"} && `;
  /* Bedrooms */
  if (Bedrooms !== "*") FinalString += `bedrooms:=${Bedrooms} && `;
  /* Bathrooms */
  if (Bathrooms !== "*") FinalString += `bathrooms:=${Bathrooms} && `;

  const FinalString1 =
    FinalString +
    `sellingPrice:=> ${PriceRange[0]} && sellingPrice:=<${PriceRange[1]}`;
  const FinalString2 =
    FinalString +
    `rentalPrice:=> ${PriceRange[0]} && rentalPrice:=<${PriceRange[1]}`;

  return [FinalString1, FinalString2];
}
